/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInternalObjectDto } from '../../models/create-internal-object-dto';
import { ObjectResDto } from '../../models/object-res-dto';

export interface LambdaControllerCreateObject$Params {
  body: CreateInternalObjectDto;
}

export function lambdaControllerCreateObject(
  http: HttpClient,
  rootUrl: string,
  params: LambdaControllerCreateObject$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ObjectResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    lambdaControllerCreateObject.PATH,
    'put',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ObjectResDto>;
      }),
    );
}

lambdaControllerCreateObject.PATH = '/storage/internal/object';
